import { Model, belongsTo, hasMany } from 'miragejs';
import Papa from 'papaparse';

export default Model.extend({
  employee: belongsTo('employee'),
  flow: belongsTo('flow'),
  location: belongsTo('location'),
  user: belongsTo('user'),
  invites: hasMany('invite'),
  additionalHosts: hasMany('employee'),

  save() {
    const { csv, flow, location, employee, groupName, expectedArrivalTime } = this;
    const parsed = Papa.parse(csv, {
      header: true,
      dynamicTyping: false,
      skipEmptyLines: true,
    });

    this.csv = '';

    const csvInvites = parsed.data.map((row) => {
      const invite = {
        employee,
        expectedArrivalTime,
        flow,
        groupName,
        location,
        flowName: flow.name,
        userData: [],
      };

      if (employee?.name) invite.userData.Host = employee.name;

      for (const key in row) {
        const value = `${row[key]}`.trim();

        switch (`${key}`.trim()) {
          case '':
            break;
          case 'invitee_name':
            invite.fullName = value;
            break;
          case 'invitee_email':
            invite.email = value;
            break;
          case 'additional_guests':
            invite.additionalGuests = parseInt(value, 10) || 0;
            break;
          case 'private_notes':
            invite.privateNotes = value;
            break;
          case 'property_notes':
            invite.propertyNotes = value;
            break;
          default:
            invite.userData[key] = value;
            break;
        }
      }

      return this._schema.invites.new(invite);
    });

    this.invites.models = [...this.invites.models, ...csvInvites];

    return Model.prototype.save.call(this);
  },
});
